import React, {
  useEffect,
  useMemo,
  useCallback,
  useRef,
  useState,
} from "react";
import { invoiceList } from "../../../core/data/json/invoicelist";
import { Link } from "react-router-dom";
import { useColumnOrderSave } from "../../../core/common/useColumnOrderSave";
import DateRangePicker from "react-bootstrap-daterangepicker";
import CollapseHeader from "../../../core/common/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { all_routes } from "../../router/all_routes";
import CountUp from "react-countup";
import {
  createInvoice,
  deleteInvoice,
  fetchInvoicesByLeadOwner,
  Invoice,
  deleteInvoiceProposalsBulk,
} from "../../../api/invoiceproposal";
import { toast } from "react-toastify";
import { Deal, fetchAllDeals, fetchDealById } from "../../../api/deal";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { highlightMatch } from "../../../core/common/highlightmatch";
import Table from "../../../core/common/dataTable/index";
import { Avatar, Dropdown, Menu, Button,Checkbox } from "antd";
import { DownOutlined,FunnelPlotFilled } from '@ant-design/icons';
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
import { RootState } from "../../../core/data/redux/store";
import { initialSettings } from "../../../core/common/selectoption/selectoption";
import { Modal } from "react-bootstrap";
import debounce from "lodash/debounce";
import AnimatedBadge from "../../../core/common/AnimatedBadge/index";
import SequentialHighlight from "../../../core/common/SequentialHighlight";

import ColumnManagement from "../../../core/common/ColumnManagement";
import ScrollToTop from "../../../core/common/ScrollToTop";
import ModalDeleteEffect from "../../../core/common/ModalDeleteEffect";
import SubmoduleHoverCard from "../../../core/common/SubCard2Button";
import TextCopy2 from "../../../core/common/textcopy2";
import { Ellipsis } from "react-bootstrap/esm/PageItem";
import InvoiceDetailsModal from "../../../core/common/InvoiceDetailsModal";


const defaultVisibleColumns = {
  invoice_proposal_id: true,
    invoice_date: true,
    validation_date: true,
    status: true,
    subtotalamount: true,
    cgst: true,
    sgst: true,
    igst: true,
    discount: true,
    gst_number: true,
    //notes: true,
    lead_owner: true,
    company_contact: true,
    invoice_leads: true,
    deal_value: true,
    product: true,
    created_at: true,
    action: true,
};

const defaultColumnOrder = [
  "invoice_proposal_id",
  "invoice_date",
  "validation_date",
  "status",
  "subtotalamount",
  "cgst",
  "sgst",
  "igst",
  "discount",
  "gst_number",
  //"notes",
  "lead_owner",
  "company_contact",
  "invoice_leads",
  "deal_value",
  "product",
  "created_at",
  "action",
];

const columnLabels = {
  company_contact: "Contact",
  invoice_proposal_id: "Invoice ID",
  invoice_date: "Invoice Date",
  validation_date: "Validation Date",
  lead_owner: "Lead Owner",
  status: "Status",
  subtotalamount: "Subtotal",
  cgst: "CGST",
  sgst: "SGST",
  igst: "IGST",
  discount: "Discount",
  gst_number: "GST Number",
  //notes: "Notes",
  invoice_leads: "Leads Info",
  deal_value: "Deal Value",
  product: "Product",
  created_at: "Created At",
  action: "Actions",
};

const InvoiceList = () => {
  const route = all_routes;
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [orderedData, setOrderedData] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [deleteInvoiceId, setDeleteInvoiceId] = React.useState<string | null>(
    null
  );
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [deals, setDeals] = useState<Deal[]>([]);
  const [selectedDeal, setSelectedDeal] = useState<Deal | null>(null);
  const [invoiceDate, setInvoiceDate] = useState<Date | null>(null);
  const [validationDate, setValidationDate] = useState<Date | null>(null);
  const [status, setStatus] = useState<string>("notpaid");
  const [notes, setNotes] = useState<string>("");
  const [terms, setTerms] = useState<string>("");
  const [rows, setRows] = useState<any[]>([]);
  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [igst, setIgst] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);
  const [dealInvoice, setDealInvoice] = useState<Deal | null>(null);
  const [dealCache, setDealCache] = useState<Record<string, Deal>>({});
  const offcanvasRef = useRef<HTMLDivElement | null>(null);
  const invoiceRef = useRef<HTMLDivElement>(null);
  const currencyCodeMap: { [key: string]: string } = {
    INR: "INR",
    Dollar: "USD",
    Euro: "EUR",
    Pound: "GBP",
  };
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  const [sortOption, setSortOption] = useState("recently_added");
  const [dateRange, setDateRange] = useState<{ start: Date; end: Date }>({
    start: new Date(2000, 0, 1),
    end: new Date(),
  });
  const [isDeleting, setIsDeleting] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [filterClient, setFilterClient] = useState<string[]>([]);
  const [filterStatus, setFilterStatus] = useState<string[]>([]);
  const [filterProduct, setFilterProduct] = useState<string[]>([]);
  const [filterInvoiceId, setFilterInvoiceId] = useState<string[]>([]);
  const [filterLeadOwner, setFilterLeadOwner] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [alphaFilter, setAlphaFilter] = useState<string>("All");
  const [alphaFilterleadowner, setAlphaFilterleadowner] = useState<string>("All");
  const [alphaFilterproduct, setAlphaFilterproduct] = useState<string>("All");
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);
  const userId = useSelector((state: RootState) => state.auth.user_id);
  const userRole = useSelector((state: RootState) => state.auth.role);
  const [filterLeadOwners, setFilterLeadOwners] = useState<string[]>([]);
const [selectedInvoiceForView, setSelectedInvoiceForView] = useState<Invoice | null>(null);
const [showViewInvoiceModal, setShowViewInvoiceModal] = useState(false);
  const [filterClients, setFilterClients] = useState<string[]>([]); // Already exists? If not, add.
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]); // Replace single statusFilter with multi.
  const [filterProducts, setFilterProducts] = useState<string[]>([]); // Already exists? If not, add.
  const [clientSearch, setClientSearch] = useState("");
  const [statusSearch, setStatusSearch] = useState("");
  const [productSearch, setProductSearch] = useState("");
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const [filterOwners, setFilterOwners] = useState<string[]>([]);
  const [ownerSearch, setOwnerSearch] = useState("");
  const debouncedSetSearch = useMemo(() => debounce(setSearchText, 300), []);
  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearchText(searchText), 300);
    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    const styleId = "animated-badge-keyframes";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = `
      @keyframes shine {
        0% {
          transform: skewX(-20deg) translateX(-150%);
        }
        50% {
           transform: skewX(-20deg) translateX(150%);
        }
        100% {
          transform: skewX(-20deg) translateX(150%);
        }
      }
    `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  useEffect(() => {
    const makeModalDraggable = (modalId: string) => {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalDialog = modalElement.querySelector('.modal-dialog') as HTMLElement;
      const modalHeader = modalElement.querySelector('.modal-header') as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      // Reset position when modal is shown
      const resetPosition = () => {
        // Reset all position variables
        currentX = 0;
        currentY = 0;
        initialX = 0;
        initialY = 0;
        startX = 0;
        startY = 0;
        isDragging = false;

        // Remove only the inline styles that were added during dragging
        modalDialog.style.position = '';
        modalDialog.style.top = '';
        modalDialog.style.left = '';
        modalDialog.style.transform = '';
        modalDialog.style.margin = '';
        modalDialog.style.transition = '';
        modalDialog.style.width = '';
        modalDialog.style.maxWidth = '';

        // Restore centered class if it was removed
        if (!modalDialog.classList.contains('modal-dialog-centered')) {
          modalDialog.classList.add('modal-dialog-centered');
        }
      };

      // Listen for modal show event - reset when modal is about to show
      const handleShow = () => {
        // Reset immediately when modal starts showing
        resetPosition();
      };

      // Listen for modal shown event - ensure reset after modal is fully displayed
      const handleShown = () => {
        // Double-check reset after modal is fully shown
        resetPosition();
      };

      // Listen for modal hidden event - reset when modal is fully hidden
      const handleHidden = () => {
        resetPosition();
      };

      modalElement.addEventListener('show.bs.modal', handleShow);
      modalElement.addEventListener('shown.bs.modal', handleShown);
      modalElement.addEventListener('hidden.bs.modal', handleHidden);

      const dragStart = (e: MouseEvent) => {
        // Only allow dragging from header, not from close button or other interactive elements
        const target = e.target as HTMLElement;
        if (target.closest('.btn-close') || target.closest('button') || target.closest('input') || target.closest('select')) {
          return;
        }

        if (e.target === modalHeader || modalHeader.contains(e.target as Node)) {
          isDragging = true;
          modalHeader.style.cursor = 'move';

          // Get current position and size of modal dialog
          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          // Get computed styles to preserve the modal's size
          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          // Remove centered class to allow free movement
          modalDialog.classList.remove('modal-dialog-centered');

          // Set initial position based on current position
          modalDialog.style.position = 'fixed';
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = '0';
          modalDialog.style.transform = 'none';
          modalDialog.style.transition = 'none';

          // Preserve the modal's width and max-width to prevent size change
          if (currentWidth && currentWidth !== 'auto' && currentWidth !== '0px') {
            modalDialog.style.width = currentWidth;
          }
          if (currentMaxWidth && currentMaxWidth !== 'none' && currentMaxWidth !== '0px') {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (currentMinWidth && currentMinWidth !== '0px' && currentMinWidth !== 'auto') {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;

        e.preventDefault();

        // Calculate new position
        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        // Get modal dialog dimensions
        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        // Constrain to viewport
        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        // Update position
        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;

        // Store current position for next drag
        currentX = constrainedX;
        currentY = constrainedY;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = 'move';
          modalDialog.style.transition = '';
          // Keep the fixed positioning during drag, but allow reset on next open
        }
      };

      // Add cursor style to header
      modalHeader.style.cursor = 'move';
      modalHeader.style.userSelect = 'none';

      // Event listeners
      modalHeader.addEventListener('mousedown', dragStart);
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', dragEnd);

      // Cleanup function
      return () => {
        modalElement.removeEventListener('show.bs.modal', handleShow);
        modalElement.removeEventListener('shown.bs.modal', handleShown);
        modalElement.removeEventListener('hidden.bs.modal', handleHidden);
        modalHeader.removeEventListener('mousedown', dragStart);
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('mouseup', dragEnd);
      };
    };

    const cleanup = makeModalDraggable('delete_invoice');

    return () => {
      cleanup?.();
    };
  }, []);

  // Make React Bootstrap bulk delete modal draggable
  useEffect(() => {
    const setupModalDraggable = (modalElement: HTMLElement) => {
      if (modalElement.hasAttribute('data-draggable-setup')) return;
      modalElement.setAttribute('data-draggable-setup', 'true');

      const modalDialog = modalElement.querySelector('.modal-dialog') as HTMLElement;
      const modalHeader = modalElement.querySelector('.modal-header') as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      const resetPosition = () => {
        isDragging = false;
        modalDialog.style.position = '';
        modalDialog.style.top = '';
        modalDialog.style.left = '';
        modalDialog.style.transform = '';
        modalDialog.style.margin = '';
        modalDialog.style.transition = '';
        modalDialog.style.width = '';
        modalDialog.style.maxWidth = '';

        if (!modalDialog.classList.contains('modal-dialog-centered')) {
          modalDialog.classList.add('modal-dialog-centered');
        }
      };

      const dragStart = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (target.closest('.btn-close') || target.closest('button') || target.closest('input') || target.closest('select')) {
          return;
        }

        if (e.target === modalHeader || modalHeader.contains(e.target as Node)) {
          isDragging = true;
          modalHeader.style.cursor = 'move';

          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          modalDialog.classList.remove('modal-dialog-centered');

          modalDialog.style.position = 'fixed';
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = '0';
          modalDialog.style.transform = 'none';
          modalDialog.style.transition = 'none';

          if (currentWidth && currentWidth !== 'auto' && currentWidth !== '0px') {
            modalDialog.style.width = currentWidth;
          }
          if (currentMaxWidth && currentMaxWidth !== 'none' && currentMaxWidth !== '0px') {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (currentMinWidth && currentMinWidth !== '0px' && currentMinWidth !== 'auto') {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();

        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = 'move';
          modalDialog.style.transition = '';
        }
      };

      modalHeader.style.cursor = 'move';
      modalHeader.style.userSelect = 'none';

      modalHeader.addEventListener('mousedown', dragStart);
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', dragEnd);

      const handleHidden = () => {
        resetPosition();
        modalElement.removeAttribute('data-draggable-setup');
      };

      modalElement.addEventListener('hidden.bs.modal', handleHidden);
    };

    const checkAndSetup = () => {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach((modal) => {
        const modalEl = modal as HTMLElement;
        const h4 = modalEl.querySelector('h4')?.textContent || '';

        if (h4.includes('Confirm Bulk Delete') && !modalEl.hasAttribute('data-draggable-setup')) {
          setTimeout(() => setupModalDraggable(modalEl), 50);
        }
      });
    };

    const interval = setInterval(checkAndSetup, 100);

    return () => {
      clearInterval(interval);
    };
  }, [showBulkDeleteModal]);

  // Load invoices once
  const loadInvoices = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (userId) {
        const data = await fetchInvoicesByLeadOwner(userId);
        setInvoices(data);
        setOrderedData(data);
      }
    } catch (err) {
      setError("Failed to load invoices");
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    loadInvoices();
  }, [loadInvoices]);

  // Load deals
  useEffect(() => {
    const loadDeals = async () => {
      try {
        const data = await fetchAllDeals();
        setDeals(data);
      } catch (err) {
        console.error("Failed to fetch deals");
      }
    };
    loadDeals();
  }, []);

  const refresh = useCallback(() => {
    setSelectedDeal(null);
    setInvoiceDate(null);
    setValidationDate(null);
    setStatus("notpaid");
    setNotes("");
    setTerms("");
    setRows([]);
    setSubtotal(0);
    setDiscount(0);
    setCgst(0);
    setSgst(0);
    setIgst(0);
    setTotal(0);
  }, []);

  const handleDateChange1 = useCallback((date: Date | null) => {
    setSelectedDate1(date);
  }, []);

  const handleStarToggle = useCallback((index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  }, []);

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());

  const initializeStarsState = useCallback(() => {
    const starsState: { [key: number]: boolean } = {};
    invoiceList.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  }, []);

  useEffect(() => {
    initializeStarsState();
  }, [initializeStarsState]);

  const dispatch = useDispatch();
  const toggleEditInvoice = useCallback(() => {
    setEditInvoice((prev) => !prev);
  }, []);

  const [editInvoice, setEditInvoice] = useState(false);
  const [clientList, setClientList] = useState<
    { label: string; value: string }[]
  >([]);
  const [productOptions, setProductOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const handleConfirmDelete = useCallback(async () => {
    if (!deleteInvoiceId) return;
    setIsDeleting(true);
    try {
      await deleteInvoice(deleteInvoiceId);
      setShowDeleteModal(false);
      setDeleteInvoiceId(null);
      await loadInvoices();
    } catch (error) {
      toast.error("Failed to delete invoice");
    }
    finally {
      setIsDeleting(false);
    }
  }, [deleteInvoiceId, loadInvoices]);

  const handleBulkDelete = async () => {
    if (selectedInvoices.length === 0) return;
    setIsDeleting(true);
  try {
    await deleteInvoiceProposalsBulk(selectedInvoices);

    toast.success("Selected invoices deleted");

    setShowBulkDeleteModal(false);
    setSelectedInvoices([]);
    loadInvoices(); // refresh list

  } catch (error) {
    toast.error("Failed to delete invoices");
  } finally {
    setIsDeleting(false);
    setLoading(false);
  }
};

  const handleDateApply = useCallback((event: any, picker: any) => {
    setDateRange({
      start: picker.startDate.toDate(),
      end: picker.endDate.toDate(),
    });
  }, []);

  const currency = useMemo(
    () => [
      { value: "Choose", label: "Choose" },
      { value: "Dollar", label: "Dollar" },
      { value: "Euro", label: "Euro" },
      { value: "Pound", label: "Pound" },
      { value: "Rupee", label: "Rupee" },
    ],
    []
  );

  const handleDealChange = useCallback(
    (option: any) => {
      const deal = deals.find((d) => d.deal_id === option?.value);
      setSelectedDeal(deal || null);

      if (deal && deal.leads) {
        const lead = deal.leads;
        const itemRow = {
          product_id: deal.product?.product_id ?? null,
          product_name: deal.product?.product_name ?? "N/A",
          product_price: deal.product?.product_price ?? 0,
          no_logins: lead.no_logins ?? 0,
          rate_per_login: lead.rate_per_login ?? 0,
          cgst_percentage: lead.cgst_percentage ?? 0,
          sgst_percentage: lead.sgst_percentage ?? 0,
          igst_percentage: lead.igst_percentage ?? 0,
          proposal_discount: lead.proposal_discount_percentage ?? 0,
          cgst: lead.cgst ?? 0,
          sgst: lead.sgst ?? 0,
          igst: lead.igst ?? 0,
          discount: lead.proposal_discount ?? 0,
          amount: lead.total_amount ?? 0,
        };

        setSubtotal(lead.amount ?? 0);
        setDiscount(lead.proposal_discount ?? 0);
        setCgst(lead.cgst ?? 0);
        setSgst(lead.sgst ?? 0);
        setIgst(lead.igst ?? 0);
        setTotal(lead.total_amount ?? 0);
        setRows([itemRow]);
      } else {
        setSubtotal(0);
        setDiscount(0);
        setCgst(0);
        setSgst(0);
        setIgst(0);
        setTotal(0);
        setRows([]);
      }
    },
    [deals]
  );

  const formatDateOnly = useCallback((date: Date) => {
    return date.toISOString().split("T")[0];
  }, []);

  const handleSubmit = useCallback(async () => {
    if (!selectedDeal || !invoiceDate || !validationDate) {
      toast.error(
        "Please select a deal and set both invoice and validation dates."
      );
      return;
    }

    const lead = selectedDeal.leads;

    const payload = {
      deal_id: selectedDeal.deal_id,
      invoice_date: formatDateOnly(invoiceDate),
      validation_date: formatDateOnly(validationDate),
      status,
      subtotalamount: lead.amount,
      cgst: lead.cgst,
      sgst: lead.sgst,
      igst: lead.igst,
      cgst_percentage: lead.cgst_percentage,
      sgst_percentage: lead.sgst_percentage,
      igst_percentage: lead.igst_percentage,
      invoice_no_logins: lead.no_logins,
      invoice_rate_per_login: lead.rate_per_login,
      discount: lead.proposal_discount,
      invoice_total_amount: lead.total_amount,
      proposal_discount_percentage: lead.proposal_discount_percentage,
      deal: {
        deal_id: selectedDeal.deal_id,
        deal_value: parseFloat(selectedDeal.deal_value),
        currency: selectedDeal.currency,
        product: selectedDeal.product,
        contact: selectedDeal.contact,
        leads: lead,
      },
    };

    try {
      await createInvoice(payload);
      loadInvoices();
      refresh();
      const closeBtn = document.querySelector('#offcanvas_add [data-bs-dismiss="offcanvas"]');
      if (closeBtn) {
        (closeBtn as HTMLElement).click();
      }
    } catch (err) {
      console.error("Failed to create invoice", err);
    }
  }, [
    selectedDeal,
    invoiceDate,
    validationDate,
    status,
    formatDateOnly,
    loadInvoices,
    refresh,
  ]);

  const handleInvoiceView = useCallback(
    async (e: React.MouseEvent, record: Invoice) => {
      e.preventDefault();
      setSelectedInvoice(record);
      const dealId = record.deal.deal_id;
      if (!dealCache[dealId]) {
        try {
          const fullDeal = await fetchDealById(dealId);
          setDealCache((prev) => ({ ...prev, [dealId]: fullDeal }));
          setDealInvoice(fullDeal);
        } catch {
          setDealInvoice(null);
        }
      } else {
        setDealInvoice(dealCache[dealId]);
      }
    },
    [dealCache]
  );

  
  const handleDownloadPDF = useCallback(async () => {
    if (!invoiceRef.current) return;

    window.scrollTo(0, 0);

    const el = invoiceRef.current;
    el.style.width = "830px";
    el.style.minHeight = "1123px";
    el.style.background = "#ffffff";
    el.style.padding = "10px";

    const elementsToHide = el.querySelectorAll(".no-print");
    elementsToHide.forEach(
      (el) => ((el as HTMLElement).style.display = "none")
    );

    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      onclone: (clonedDoc) => {
        clonedDoc.getElementById("view_invoice")?.classList.remove("modal");
      },
    });

    elementsToHide.forEach((el) => ((el as HTMLElement).style.display = ""));

    const imgData = canvas.toDataURL("image/png");

    if (!imgData.startsWith("data:image/png")) {
      console.error("Generated image is not a valid PNG");
      return;
    }

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(
      `Invoice_${selectedInvoice?.invoice_proposal_id || "document"}.pdf`
    );
    toast.success("PDF downloaded successfully!");
  }, [selectedInvoice]);

  const filteredInvoices = useMemo(() => {
    return invoices
      .filter((inv) => {
        const textMatch =
          debouncedSearchText.trim() === "" ||
          [
            inv.invoice_proposal_id,
            inv.status,
            inv.deal?.contact?.users?.name,
            inv.deal?.contact?.users?.phone_no,
            inv.deal?.contact?.users?.email,
            inv.deal?.product?.product_name,
            inv.deal?.deal_value,
            inv.subtotalamount,
            inv.invoice_amount,
            inv.invoice_tax,
            inv.discount,
            inv.gst_number,
            inv.notes,
            inv.taxtotalamount,
            inv.invoice_no_logins,
            inv.deal.contact.contact_person_name,
            inv.deal.contact.company_name,
          ].some((field) =>
            field
              ?.toString()
              .toLowerCase()
              .includes(debouncedSearchText.toLowerCase())
          );

        const dateMatch =
          !dateRange.start ||
          !dateRange.end ||
          !inv.invoice_date ||
          (new Date(inv.invoice_date) >= dateRange.start &&
            new Date(inv.invoice_date) <= dateRange.end);

           const alphaMatch =
  alphaFilter === "All" ||
  (inv.deal.contact.company_name || "").toLowerCase().startsWith(alphaFilter.toLowerCase()); 

  const alphaMat =
  alphaFilterleadowner === "All" ||
  (inv.deal?.contact?.users?.name || "").toLowerCase().startsWith(alphaFilterleadowner.toLowerCase());
          const alphaMatproduct =
  alphaFilterproduct === "All" ||
  (inv.deal?.product?.product_name || "").toLowerCase().startsWith(alphaFilterproduct.toLowerCase());
        const statusMatch =
          statusFilter === "all" || inv.status?.toLowerCase() === statusFilter;

          const leadOwnerFunnelMatch =
        filterLeadOwners.length === 0 ||
        filterLeadOwners.includes(inv.deal?.contact?.users?.name || "");

      



        const clientMatch =
          filterClient.length === 0 ||
          (inv.deal?.contact?.company_name &&
            filterClient.includes(inv.deal.contact.company_name));

        const productMatch =
          filterProduct.length === 0 ||
          (inv.deal?.product?.product_name &&
            filterProduct.includes(inv.deal.product.product_name));

        const invoiceIdMatch =
          filterInvoiceId.length === 0 ||
          (inv.invoice_proposal_id &&
            filterInvoiceId.includes(inv.invoice_proposal_id));

        const leadOwnerMatch =
          filterLeadOwner.length === 0 ||
          (inv.deal?.contact?.contact_person_name &&
            filterLeadOwner.includes(inv.deal.contact.contact_person_name));

        return (
          textMatch &&
          dateMatch &&
          statusMatch &&
          clientMatch &&
          productMatch &&
          invoiceIdMatch &&
          leadOwnerMatch &&
          alphaMatch &&
          alphaMat &&
          alphaMatproduct &&
          leadOwnerFunnelMatch 
        );
      })
      .sort((a, b) => {
        if (sortOption === "asc")
          return (a.invoice_proposal_id ?? "").localeCompare(
            b.invoice_proposal_id ?? ""
          );
        if (sortOption === "desc")
          return (b.invoice_proposal_id ?? "").localeCompare(
            a.invoice_proposal_id ?? ""
          );
        if (sortOption === "recently_viewed")
          return (
            new Date(b.updated_at ?? "").getTime() -
            new Date(a.updated_at ?? "").getTime()
          );
        if (sortOption === "recently_added")
          return (
            new Date(b.created_at ?? "").getTime() -
            new Date(a.created_at ?? "").getTime()
          );
        return 0;
      });
  }, [
    invoices,
    debouncedSearchText,
    sortOption,
    dateRange,
    statusFilter,
    filterClient,
    filterProduct,
    filterInvoiceId,
    filterLeadOwner,
    alphaFilter,
    alphaFilterleadowner,
    alphaFilterproduct,
    filterLeadOwners,

  ]);

  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    defaultVisibleColumns
  );

  // Column order state for drag and drop (only non-sticky columns)
  const [columnKeys, setColumnKeys] = useState<string[]>(() => {
    const saved = localStorage.getItem("invoicesColumnKeys");
    if (saved) return JSON.parse(saved);
    return defaultColumnOrder;
  });

  // Hook for save prompt on navigation/refresh
  const { SaveModal } = useColumnOrderSave({
    columnKeys,
    localStorageKey: "invoicesColumnKeys",
    defaultOrder: defaultColumnOrder,
  });

  useEffect(() => {
  setSelectedInvoices(prev =>
    prev.filter(id =>
      filteredInvoices.some(inv => inv.invoice_proposal_id === id)
    )
  );
}, [filteredInvoices]);

  const handleToggleColumn = useCallback((key: string) => {
    setVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const uniqueClients = useMemo(
    () =>
      Array.from(
        new Set(invoices.map((inv) => inv.deal?.contact?.company_name || ""))
      ).filter((n) => n),
    [invoices]
  );

  const uniqueStatuses = useMemo(
    () =>
      Array.from(new Set(invoices.map((inv) => inv.status || ""))).filter(
        (n) => n
      ),
    [invoices]
  );

  const uniqueProducts = useMemo(
    () =>
      Array.from(
        new Set(invoices.map((inv) => inv.deal?.product?.product_name || ""))
      ).filter((n) => n),
    [invoices]
  );

  const uniqueOwners = useMemo(
    () =>
      Array.from(
        new Set(invoices.map((inv) => inv.deal?.contact?.users?.name || ""))
      ).filter((n) => n),
    [invoices]
  );

  const columns = useMemo(() => {
  // 1️⃣ Build columns array
  const columnsArray = [
    {
          title: "S.No",
          key: "index",
          fixed: "left",
          render: (_text: any, _record: any, index: number) =>
            (currentPage - 1) * pageSize + index + 1,
        },
        visibleColumns.company_contact && {
          title: (
    <div
      className="flex items-center justify-between"
      style={{ height: 22, whiteSpace: "nowrap" }}
      onClick={(e) => e.stopPropagation()}   // ← prevents header sort/expand
    >
      <span className="me-2">Client</span>

      {/* Ant Design Dropdown – pure, tiny, beautiful */}
      <Dropdown
        trigger={["click"]}
        onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)} // optional: close on outside click
        overlay={
          <Menu
            selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
            onClick={({ key }) => setAlphaFilter(key === "All" ? "" : key)}
            style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          >
            <Menu.Item key="All" className="text-center">
              All
            </Menu.Item>
            {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
              <Menu.Item key={letter} className="text-center">
                {letter}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 12,
            height: 17,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            background: "#fafafa",
          }}
        >
          {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
          <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
        </Button>
      </Dropdown>
    </div>
  ),
          key: "company_contact",
          fixed: "left",
          render: (_: any, record: Invoice) => {
            const company = record.deal?.contact?.company_name || "N/A";
            const contact = record.deal?.contact?.contact_person_name || "N/A";
            const initial = company.charAt(0).toUpperCase();

            const handleInvoiceView = async (e: React.MouseEvent) => {
            e.preventDefault();
            setSelectedInvoice(record);
            try {
              const fullDeal = await fetchDealById(record.deal.deal_id);
              setDealInvoice(fullDeal);
            } catch {
              setDealInvoice(null);
            }
          };

            return (
              <div className="d-flex align-items-center gap-2">
                <Avatar
                shape="square"
                className="btn btn-primary"
                style={{
                  width: 36,
                  height: 36,
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                {initial}
              </Avatar>
                <div className="d-flex flex-column">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#view_invoice"
                    onClick={handleInvoiceView}
                  >
                    <strong>
                      {highlightMatch(company, debouncedSearchText)}
                    </strong>
                  </Link>
                  <span className="text-muted">
                    {highlightMatch(contact, debouncedSearchText)}
                  </span>
                </div>
              </div>
            );
          },
        },
        visibleColumns.invoice_proposal_id && {
          title: "Invoice ID",
          dataIndex: "invoice_proposal_id",
          key: "invoice_proposal_id",
          sorter: true,
          render: (text: string) => {
          const invoiceId = text?.trim() || "N/A";

          return (
            <TextCopy2
              text={invoiceId}
              searchQuery={debouncedSearchText}
              showText={true}
              showIcon={true}
              showDocumentIcon={true}   // ❌ no document icon
            />
          );
        },
        },
        visibleColumns.invoice_date && {
          title: "Invoice Date",
          dataIndex: "invoice_date",
          key: "invoice_date",
          sorter: true,
          render: (text: string) => (
          <TextCopy2
            text={text || "N/A"}
            searchQuery={debouncedSearchText}
            showDateIcon={true}
            showIcon={false}
          />
        ),
        },
        visibleColumns.validation_date && {
          title: "Validation Date",
          dataIndex: "validation_date",
          key: "validation_date",
          sorter: true,
          render: (text: string) => (
          <TextCopy2
            text={text || "N/A"}
            searchQuery={debouncedSearchText}
            showDateIcon={true}
            showIcon={false}
          />
        ),
        },
        visibleColumns.lead_owner && {
          title: (
    <div
      className="flex items-center justify-between"
      style={{ height: 28, whiteSpace: "nowrap" }}
      onClick={(e) => e.stopPropagation()}   // ← prevents header sort/expand
    >
      <span className="me-2">Lead Owner</span>

      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu style={{ width: 220, maxHeight: 300, overflowY: "auto" }} onClick={(e) => e.domEvent.stopPropagation()}>
            <Menu.Item key="all" onClick={(e) => { e.domEvent.stopPropagation(); setFilterLeadOwners([]); }}>
              <Checkbox checked={filterLeadOwners.length === 0}>All Owners</Checkbox>
            </Menu.Item>
            {Array.from(
              new Set(
                invoices
                  .map(inv => inv.deal?.contact?.users?.name)
                  .filter((n): n is string => Boolean(n))  // ← THIS FIXES IT!
              )
            )
              .sort()
              .map(name => {
                const checked = filterLeadOwners.includes(name);
                return (
                  <Menu.Item
                    key={name}
                    onClick={(e) => {
                      e.domEvent.stopPropagation();
                      setFilterLeadOwners(prev =>
                        checked ? prev.filter(v => v !== name) : [...prev, name]
                      );
                    }}
                  >
                    <Checkbox checked={checked}>{name}</Checkbox>
                  </Menu.Item>
                );
              })}
          </Menu>
        }
      >
        <Button size="small" type="text" style={{ padding: "0 6px" }} onClick={(e) => e.stopPropagation()}>
          <FunnelPlotFilled style={{ fontSize: 15, color: filterLeadOwners.length > 0 ? "#1890ff" : "#000" }} />
        </Button>
      </Dropdown>

      {/* Ant Design Dropdown – pure, tiny, beautiful */}
      <Dropdown
        trigger={["click"]}
        onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)} // optional: close on outside click
        overlay={
          <Menu
            selectedKeys={alphaFilterleadowner ? [alphaFilterleadowner] : ["All"]}
            onClick={({ key }) => setAlphaFilterleadowner(key === "All" ? "" : key)}
            style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          >
            <Menu.Item key="All" className="text-center">
              All
            </Menu.Item>
            {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
              <Menu.Item key={letter} className="text-center">
                {letter}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 12,
            height: 17,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            background: "#fafafa",
          }}
        >
          {alphaFilterleadowner ? alphaFilterleadowner.toUpperCase() : "ALL"}
          <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
        </Button>
      </Dropdown>
    </div>
  ),
          dataIndex: "lead_owner",
          key: "lead_owner",
          render: (_: any, record: Invoice) => {
          const user = record.deal?.contact?.users;

          return (
            <SubmoduleHoverCard
              name={highlightMatch(user?.name || "N/A", searchText)}
              role="Invoices"
              email={user?.email}          // optional
              phone={user?.phone_no}       // optional
              contactleadowner_name={user?.name}
              dealowner_name={user?.name}
              leadowner_name={user?.name}
              createdAt={record.created_at}
              variant2={["contactleadOwner", "dealOwner", "leadOwner"]}
            />
          );
        },
},
        visibleColumns.status && {
          title: (
  <div
    className="flex items-center justify-between"
    style={{ height: 28, whiteSpace: "nowrap" }}
    onClick={(e) => e.stopPropagation()}
  >
    <span className="me-2">Status</span>

    <Dropdown
      trigger={["click"]}
      overlay={
        <Menu
          selectedKeys={[statusFilter]} // array of string
          onClick={({ key }) => setStatusFilter(key)}
          style={{ width: 170 }}
        >
          <Menu.Item key="all">
            <i className="bi bi-filter me-2 text-secondary" />
            All Invoices
          </Menu.Item>

          <Menu.Item key="paid">
            <i className="bi bi-check-circle me-2 text-success" />
            Paid
          </Menu.Item>

          <Menu.Item key="notpaid">
            <i className="bi bi-x-circle me-2 text-danger" />
            Not Paid
          </Menu.Item>

          <Menu.Item key="partialpaid">
            <i className="bi bi-hourglass-split me-2 text-purple" />
            Partial Paid
          </Menu.Item>
        </Menu>
      }
    >
      <Button size="small" type="text" onClick={(e) => e.stopPropagation()}>
        <FunnelPlotFilled
          style={{
            fontSize: 15,
            height: 17,
            color: statusFilter !== "all" ? "#1890ff" : "#000000ff",
          }}
        />
      </Button>
    </Dropdown>
  </div>
),
          dataIndex: "status",
          key: "status",
          sorter: true,
          render: (text: string) => (
  <AnimatedBadge
    status={text || "Not Updated"}
  />
),

        },
        visibleColumns.subtotalamount && {
          title: "Subtotal Amount",
          dataIndex: "subtotalamount",
          key: "subtotalamount",
          sorter: true,
          render: (amount: number | null) => amount?.toLocaleString() ?? "0",
        },
        visibleColumns.cgst && {
          title: "CGST Amount",
          dataIndex: "cgst",
          key: "cgst",
          sorter: true,
          render: (amount: number | null) => amount?.toLocaleString() ?? "0",
        },
        visibleColumns.sgst && {
          title: "SGST Amount",
          dataIndex: "sgst",
          key: "sgst",
          sorter: true,
          render: (amount: number | null) => amount?.toLocaleString() ?? "0",
        },
        visibleColumns.igst && {
          title: "IGST Amount",
          dataIndex: "igst",
          key: "igst",
          sorter: true,
          render: (amount: number | null) => amount?.toLocaleString() ?? "0",
        },
        visibleColumns.discount && {
          title: "Discount (%)",
          dataIndex: "discount",
          key: "discount",
          sorter: true,
          render: (discount: number | null) =>
            discount ? `${discount.toLocaleString()}%` : "0%",
        },
        visibleColumns.gst_number && {
          title: "GST Number",
          dataIndex: "gst_number",
          key: "gst_number",
          sorter: true,
          render: (gst: string | null) => gst || "N/A",
        },
        // visibleColumns.notes && {
        //   title: "Notes",
        //   dataIndex: "notes",
        //   key: "notes",
        //   render: (notes: string | null) => notes || "No notes",
        // },
        visibleColumns.invoice_leads && {
          title: "Leads (No Logins / Rate per Login)",
          dataIndex: "invoice_no_logins",
          key: "invoice_leads",
          render: (_: any, record: any) =>
            record.invoice_no_logins && record.invoice_rate_per_login
              ? `${
                  record.invoice_no_logins
                } / ${record.invoice_rate_per_login.toLocaleString()}`
              : "N/A",
        },
        visibleColumns.deal_value && {
          title: "Deal Value (Currency)",
          key: "deal_value",
          render: (_: any, record: Invoice) =>
            record.deal?.deal_value != null
              ? `${record.deal.deal_value.toLocaleString()} ${
                  record.deal.currency
                }`
              : `0 ${record.deal?.currency ?? "N/A"}`,
        },
        visibleColumns.product && {
          title: (
    <div
      className="flex items-center justify-between"
      style={{ height: 22, whiteSpace: "nowrap" }}
      onClick={(e) => e.stopPropagation()}   // ← prevents header sort/expand
    >
      <span className="me-2">Product (Name / Price)</span>

      <Dropdown trigger={["click"]} overlay={
        <Menu style={{ width: 220, maxHeight: 300, overflowY: "auto" }} onClick={(e) => e.domEvent.stopPropagation()}>
          <Menu.Item key="all" onClick={(e) => { e.domEvent.stopPropagation(); setFilterProduct([]); }}>
            <Checkbox checked={filterProduct.length === 0}>All Products</Checkbox>
          </Menu.Item>
          {Array.from(
   new Set(
     invoices.map(inv => inv.deal?.product?.product_name).filter(Boolean)
   )
 ).sort().map(name => {
   const checked = filterProduct.includes(name);
   return (
     <Menu.Item key={name} onClick={(e) => {
       e.domEvent.stopPropagation();
       setFilterProduct(prev =>
         checked ? prev.filter(v => v !== name) : [...prev, name]
       );
     }}>
       <Checkbox checked={checked}>{name}</Checkbox>
     </Menu.Item>
   );
 })}

        </Menu>
      }>
        <Button size="small" type="text" style={{ padding: "0 6px" }} onClick={(e) => e.stopPropagation()}>
          <FunnelPlotFilled style={{ fontSize: 15, color: filterProduct.length > 0 ? "#1890ff" : "#000" }} />
        </Button>
      </Dropdown>
      {/* Ant Design Dropdown – pure, tiny, beautiful */}
      <Dropdown
        trigger={["click"]}
        onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)} // optional: close on outside click
        overlay={
          <Menu
            selectedKeys={alphaFilterproduct ? [alphaFilterproduct] : ["All"]}
            onClick={({ key }) => setAlphaFilterproduct(key === "All" ? "" : key)}
            style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          >
            <Menu.Item key="All" className="text-center">
              All
            </Menu.Item>
            {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
              <Menu.Item key={letter} className="text-center">
                {letter}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 12,
            height: 22,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            background: "#fafafa",
          }}
        >
          {alphaFilterproduct ? alphaFilterproduct.toUpperCase() : "ALL"}
          <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
        </Button>
      </Dropdown>
    </div>
  ),
          key: "product",
          render: (_: any, record: Invoice) =>
            record.deal?.product
              ? highlightMatch(
                  `${
                    record.deal.product.product_name
                  } / ${record.deal.product.product_price.toLocaleString()}`,
                  debouncedSearchText
                )
              : "N/A",
        },
        visibleColumns.created_at && {
          title: "Created At",
          dataIndex: "created_at",
          key: "created_at",
          sorter: (a: any, b: any) =>
            new Date(a.created_at || "").getTime() -
            new Date(b.created_at || "").getTime(),
          render: (text: string) => {
            const date = new Date(text);
            if (isNaN(date.getTime())) return "-";

            const dateStr = date.toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            });
            const timeStr = date.toLocaleTimeString("en-IN", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });

            return (
              <div>
                <div>{highlightMatch(dateStr, debouncedSearchText)}</div>
                <div style={{ fontSize: "12px", color: "#888" }}>
                  {highlightMatch(timeStr, debouncedSearchText)}
                </div>
              </div>
            );
          },
        },
        visibleColumns.action && {
  title: "Action",
  key: "action",
  fixed: "right",
  render: (_: any, record: Invoice) => {
    const menu = (
      <Menu
        onClick={(e) => e.domEvent.stopPropagation()}
        style={{
          minWidth: 220,
          borderRadius: 8,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        {/* View Invoice */}
<Menu.Item
  key="view"
  className="d-flex align-items-center"
  onClick={() => {
    setSelectedInvoiceForView(record);
    setShowViewInvoiceModal(true);
  }}
>
  <i className="ti ti-eye text-primary me-2 fs-15" />
  <span>View Detail</span>
</Menu.Item>


        {/* Delete Invoice */}
        <Menu.Item
                key="delete"
                data-bs-toggle="modal"
                data-bs-target="#delete_invoice"
                onClick={() => {
                  setDeleteInvoiceId(record.invoice_proposal_id || "");
                  setShowDeleteModal(true);
                }}
                className="d-flex align-items-center text-danger"
              >
                <i className="ti ti-trash text-danger me-2 fs-15" />
                <span>Delete Invoice</span>
              </Menu.Item>


        {/* Download PDF */}
        <Menu.Item
          key="download"
          className="d-flex align-items-center"
          onClick={async (e) => {
            e.domEvent.preventDefault();
            if (record.invoice_proposal_id) {
              try {
                await handleDownloadPDF();
              } catch (err) {
                console.error("Download failed", err);
              }
            }
          }}
        >
          <i className="ti ti-file-text text-success me-2 fs-15" />
          <span>Download as PDF</span>
        </Menu.Item>
      </Menu>
    );

    return (
      <Dropdown
        overlay={menu}
        trigger={["click"]}
        placement="bottomRight"
        overlayClassName="table-actions-dropdown"
      >
        <Button
          size="small"
          type="text"
          className="table-action-btn"
          onClick={(e) => e.stopPropagation()}
        >
          <i className="ti ti-dots-vertical fs-14" />
        </Button>
      </Dropdown>
    );
  },
},
      ].filter(Boolean) as any[];

  // 2️⃣ Separate sticky and non-sticky columns
  const stickyLeft: any[] = [];
  const stickyRight: any[] = [];
  const nonSticky: any[] = [];

  columnsArray.forEach((col) => {
    if (col?.fixed === "left") {
      stickyLeft.push(col);
    } else if (col?.fixed === "right") {
      stickyRight.push(col);
    } else {
      nonSticky.push(col);
    }
  });

  // 3️⃣ Sort non-sticky columns by columnKeys
  const sortedNonSticky = [...nonSticky].sort((a, b) => {
    const aKey = (a.key ?? a.dataIndex) as string;
    const bKey = (b.key ?? b.dataIndex) as string;

    const aIndex = columnKeys.indexOf(aKey);
    const bIndex = columnKeys.indexOf(bKey);

    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    return 0;
  });

  // 4️⃣ Final ordered columns
  return [...stickyLeft, ...sortedNonSticky, ...stickyRight];
}, [
  visibleColumns,
  debouncedSearchText,
  currentPage,
  pageSize,
  handleInvoiceView,
  handleDownloadPDF,
  alphaFilter,
  alphaFilterleadowner,
  alphaFilterproduct,
  filterLeadOwners,
  filterProduct,
  statusFilter,
  invoices,
  columnKeys, // ✅ REQUIRED
]);

  const normalizeDate = (d: Date) =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

    const handleRowOrderChange = (newOrdered: Invoice[]) => {
    setOrderedData(newOrdered);
    // OPTIONAL: persist to backend
    // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
  };

  const wrapText = useCallback((text: string, limit = 20): string => {
    if (!text) return "";
    return text.replace(new RegExp(`(.{${limit}})`, "g"), "$1<wbr>");
  }, []);

  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );

  const handleDateChange = useCallback((date: Date | null) => {
    setSelectedDate(date);
  }, []);

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  const statusCounts = useMemo(() => {
    const counts: Record<string, number> = {};
    invoices.forEach((inv) => {
      const status = inv.status?.toLowerCase() || "unknown";
      counts[status] = (counts[status] || 0) + 1;
    });
    return counts;
  }, [invoices]);

  const formatNumber = useCallback(
    (value: number, currency: string): string => {
      const currencyCode = currencyCodeMap[currency] || "USD";
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: currency === "INR" ? 0 : 2,
        maximumFractionDigits: currency === "INR" ? 0 : 2,
      });
    },
    []
  );

  const validInvoices = useMemo(() => {
  return filteredInvoices.filter(inv => inv.invoice_proposal_id);
}, [filteredInvoices]);

const handleAccordionToggle = useCallback((sectionId: string) => {
    setOpenAccordion((prev) => (prev === sectionId ? null : sectionId));
  }, []);

  const handleFilterChange = useCallback(
    (
      value: string,
      list: string[],
      setList: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      if (list.includes(value)) {
        setList(list.filter((item) => item !== value));
      } else {
        setList([...list, value]);
      }
    },
    []
  );

  return (
    <div>
      <>
        <PageLoadProgressBar />
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        <i className="ti ti-file-invoice text-primary me-2" />
                        Invoices
                        <span className="count-title">
                        <CountUp
                          end={invoices.length}
                          duration={3.0}
                          separator=","
                        />
                      </span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Breadcrumb */}
              <nav aria-label="breadcrumb" className="page-header-breadcrumb mb-3">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link
                      to={userRole === "admin" ? route.dealsDashboard : route.leadsDashboard}
                      style={{
                        color: "#9595b5",
                        textDecoration: "none",
                        transition: "color 0.2s ease"
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = "#E41F07"}
                      onMouseLeave={(e) => e.currentTarget.style.color = "#9595b5"}
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Invoice
                  </li>
                </ol>
              </nav>
                <div className="card">
                  <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                      <div className="icon-form position-relative mb-3 mb-sm-0 ms-3">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Invoices"
                            value={searchText}
                            onChange={(e) => debouncedSetSearch(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          
                             
                          <SequentialHighlight>
                          {userRole === "admin" && (
                            <Link
                              to={route.InvoiceInsights}
                              className="btn btn-outline-warning me-2 mb-0"
                            >
                              <i className="ti ti-graph me-2" />
                              Invoice Insights
                            </Link>
                          )}
                        </SequentialHighlight>
                          {/* <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="ti ti-package-export me-2" />
                              Export
                            </Link>
                            <div className="dropdown-menu  dropdown-menu-end">
                              <ul>
                                <li>
                                  <Link to="#" className="dropdown-item">
                                    <i className="ti ti-file-type-pdf text-danger me-1" />
                                    Export as PDF
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" className="dropdown-item">
                                    <i className="ti ti-file-type-xls text-green me-1" />
                                    Export as Excel{" "}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div> */}
                          <Link
                            to="#"
                            className="btn btn-primary"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas_add"
                            style={{
                            position: "relative",
                            overflow: "hidden",
                          }}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add New Invoices
                            <span
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background: "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                              transform: "skewX(-20deg) translateX(-150%)",
                              animation: "shine 3s infinite",
                            }}
                          />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <>
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                          data-bs-toggle="dropdown"
                            >
                              {statusFilter === "all"
                                ? "All Invoices"
                                : statusFilter.charAt(0).toUpperCase() +
                                  statusFilter.slice(1)}
                            </Link>
                            <div className="dropdown-menu dropdown-menu-start">
                              <ul className="list-unstyled mb-0">
                                {["all", "paid", "notpaid"].map((status) => {
                                  const label =
                                    status === "all"
                                      ? "All Invoices"
                                      : status.charAt(0).toUpperCase() +
                                        status.slice(1);
                                  const isActive = statusFilter === status;
                                  const count =
                                    status === "all"
                                      ? invoices.length
                                      : statusCounts[status.toLowerCase()] || 0;

                                  return (
                                    <li key={status}>
                                      <Link
                                        to="#"
                                        className={`dropdown-item d-flex justify-content-between align-items-center ${
                                          isActive ? "fw-bold text-primary" : ""
                                        }`}
                                        onClick={() => setStatusFilter(status)}
                                      >
                                        <span>
                                          <i className="ti ti-dots-vertical me-2" />
                                          {label}
                                        </span>
                                        <span className="d-flex align-items-center gap-2">
                                          <span className="badge bg-light text-dark">
                                            {count}
                                          </span>
                                          {isActive && (
                                            <i className="ti ti-check" />
                                          )}
                                        </span>
                                      </Link>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>

                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                          data-bs-toggle="dropdown"
                            >
                              <i className="ti ti-sort-ascending-2 me-2" />
                              Sort
                            </Link>
                            <div className="dropdown-menu dropdown-menu-start">
                              <ul className="list-unstyled mb-0">
                                {[
                                  { label: "Ascending", value: "asc" },
                                  { label: "Descending", value: "desc" },
                                  {
                                    label: "Recently Viewed",
                                    value: "recently_viewed",
                                  },
                                  {
                                    label: "Recently Added",
                                    value: "recently_added",
                                  },
                                ].map(({ label, value }) => {
                                  const isActive = sortOption === value;
                                  return (
                                    <li key={value}>
                                      <Link
                                        to="#"
                                        className={`dropdown-item d-flex justify-content-between align-items-center ${
                                          isActive ? "fw-bold text-primary" : ""
                                        }`}
                                        onClick={() => setSortOption(value)}
                                      >
                                        <span>
                                          <i className="ti ti-circle-chevron-right me-1" />
                                          {label}
                                        </span>
                                        {isActive && (
                                          <i className="ti ti-check" />
                                        )}
                                      </Link>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>

                          <div className="icon-form">
                            <span className="form-icon">
                              <i className="ti ti-calendar" />
                            </span>
                            <DateRangePicker
                              initialSettings={initialSettings}
                              onApply={handleDateApply}
                            >
                              <input
                                className="form-control bookingrange"
                                type="text"
                                placeholder="Select date range"
                                readOnly
                                //value={`${dateRange.start.toLocaleDateString()} - ${dateRange.end.toLocaleDateString()}`}
                              />
                            </DateRangePicker>
                          </div>
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                          {selectedInvoices.length > 0 && (
  <button
    className="btn btn-outline-danger me-2 mb-0 d-flex align-items-center"
    onClick={() => setShowBulkDeleteModal(true)}
  >
    <i className="ti ti-trash-x me-2" />
    Bulk Delete ({selectedInvoices.length})
  </button>
)}
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="btn bg-soft-purple text-purple"
                              data-bs-toggle="dropdown"
                              data-bs-auto-close="outside"
                            >
                              <i className="ti ti-columns-3 me-2" />
                              Manage Columns
                            </Link>
                            <div
                              className="dropdown-menu dropdown-menu-md-end dropdown-md p-3"
                              style={{ minWidth: "300px" }}
                            >
                              <h4 className="mb-2 fw-semibold">
                                Manage columns
                              </h4>
                              <p className="mb-3">
                                Toggle to enable or disable columns as needed.
                              </p>
                              <div className="border-top pt-3">
                                {/* {Object.entries(visibleColumns).map(
                                  ([key, isVisible]) => (
                                    <div
                                      key={key}
                                      className="d-flex align-items-center justify-content-between mb-2"
                                    >
                                      <p className="mb-0 d-flex align-items-center">
                                        <i className="ti ti-grip-vertical me-2" />
                                        {key
                                          .replace(/_/g, " ")
                                          .replace(/\b\w/g, (l) =>
                                            l.toUpperCase()
                                          )}
                                      </p>
                                      <div className="status-toggle">
                                        <input
                                          type="checkbox"
                                          id={`col-${key}`}
                                          className="check"
                                          checked={isVisible}
                                          onChange={() =>
                                            handleToggleColumn(key)
                                          }
                                        />
                                        <label
                                          htmlFor={`col-${key}`}
                                          className="checktoggle"
                                        />
                                      </div>
                                    </div>
                                  )
                                )} */}
                                <ColumnManagement
                              columnKeys={columnKeys}
                              visibleColumns={visibleColumns}
                              onColumnOrderChange={setColumnKeys}
                              onColumnToggle={handleToggleColumn}
                              fixedKeys={["index", "action", "company_contact"]}
                              labels={columnLabels}
                            />
                            <div className="d-flex justify-content-end mt-3">
                            <button
                              type="button"
                              className="btn btn-light me-2"
                              onClick={() =>
                                setVisibleColumns({
                                  invoice_proposal_id: true,
    invoice_date: true,
    validation_date: true,
    status: true,
    subtotalamount: true,
    cgst: true,
    sgst: true,
    igst: true,
    discount: true,
    gst_number: true,
    //notes: true,
    lead_owner: true,
    company_contact: true,
    invoice_leads: true,
    deal_value: true,
    product: true,
    created_at: true,
    action: true,
                                })
                              }
                            >
                              Reset
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="dropdown"
                            >
                              Apply
                            </button>
                          </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-filter-btn"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                          {(filterClients.length > 0 ||
                            filterStatuses.length > 0 ||
                            filterProducts.length > 0 ||
                            filterOwners.length > 0) && (
                              <span className="badge bg-primary rounded-pill ms-2 filter-btn-badge">
                                {filterClients.length +
                                  filterStatuses.length +
                                  filterProducts.length +
                                  filterOwners.length}
                              </span>
                            )}
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-4">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" /> Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              {/* Clients Section */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "collapseOne"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("collapseOne")
                                    }
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                  >
                                    Clients
                                  </Link>
                                  {filterClients.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterClients.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "collapseOne" && (
                                  <div
                                    className="filter-set-contents accordion-collapse collapse show"
                                    id="collapseOne"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Clients"
                                          value={clientSearch}
                                          onChange={(e) =>
                                            setClientSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueClients
                                        .filter((client) =>
                                          client
                                            .toLowerCase()
                                            .includes(
                                              clientSearch.toLowerCase()
                                            )
                                        )
                                        .map((client) => (
                                          <li key={client}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterClients.includes(
                                                    client
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      client,
                                                      filterClients,
                                                      setFilterClients
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {client}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueClients.filter((client) =>
                                        client
                                          .toLowerCase()
                                          .includes(clientSearch.toLowerCase())
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Statuses Section */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "collapseTwo"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("collapseTwo")
                                    }
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                  >
                                    Statuses
                                  </Link>
                                  {filterStatuses.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterStatuses.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "collapseTwo" && (
                                  <div
                                    className="filter-set-contents accordion-collapse collapse show"
                                    id="collapseTwo"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Statuses"
                                          value={statusSearch}
                                          onChange={(e) =>
                                            setStatusSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueStatuses
                                        .filter((status) =>
                                          status
                                            .toLowerCase()
                                            .includes(
                                              statusSearch.toLowerCase()
                                            )
                                        )
                                        .map((status) => (
                                          <li key={status}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterStatuses.includes(
                                                    status
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      status,
                                                      filterStatuses,
                                                      setFilterStatuses
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {status}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueStatuses.filter((status) =>
                                        status
                                          .toLowerCase()
                                          .includes(statusSearch.toLowerCase())
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Products Section */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "collapseThree"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("collapseThree")
                                    }
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree"
                                  >
                                    Products
                                  </Link>
                                  {filterProducts.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterProducts.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "collapseThree" && (
                                  <div
                                    className="filter-set-contents accordion-collapse collapse show"
                                    id="collapseThree"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Products"
                                          value={productSearch}
                                          onChange={(e) =>
                                            setProductSearch(e.target.value)
                                          }
                                        />
                                      </div>
                                      {uniqueProducts
                                        .filter((product) =>
                                          product
                                            .toLowerCase()
                                            .includes(
                                              productSearch.toLowerCase()
                                            )
                                        )
                                        .map((product) => (
                                          <li key={product}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterProducts.includes(
                                                    product
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      product,
                                                      filterProducts,
                                                      setFilterProducts
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {product}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                      {uniqueProducts.filter((product) =>
                                        product
                                          .toLowerCase()
                                          .includes(productSearch.toLowerCase())
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr className="my-2" />
                            {/* Owners Section */}
                            <div className="filter-set-content">
                              <div className="filter-set-content-head d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className={
                                    openAccordion === "collapseFour"
                                      ? ""
                                      : "collapsed"
                                  }
                                  onClick={() =>
                                    handleAccordionToggle("collapseFour")
                                  }
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFour"
                                >
                                  Owners
                                </Link>
                                {filterOwners.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterOwners.length}
                                    </span>
                                  )}
                              </div>
                              {openAccordion === "collapseFour" && (
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="collapseFour"
                                >
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Owners"
                                        value={ownerSearch}
                                        onChange={(e) =>
                                          setOwnerSearch(e.target.value)
                                        }
                                      />
                                    </div>
                                    {uniqueOwners
                                      .filter((owner) =>
                                        owner
                                          .toLowerCase()
                                          .includes(ownerSearch.toLowerCase())
                                      )
                                      .map((owner) => (
                                        <li key={owner}>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                checked={filterOwners.includes(
                                                  owner
                                                )}
                                                onChange={() =>
                                                  handleFilterChange(
                                                    owner,
                                                    filterOwners,
                                                    setFilterOwners
                                                  )
                                                }
                                              />
                                              <span className="checkmarks" />{" "}
                                              {owner}
                                            </label>
                                          </div>
                                        </li>
                                      ))}
                                    {uniqueOwners.filter((owner) =>
                                      owner
                                        .toLowerCase()
                                        .includes(ownerSearch.toLowerCase())
                                    ).length === 0 && (
                                      <p className="text-muted px-2">
                                        No data found
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="filter-reset-btns mt-3">
                              <div className="row">
                                <div className="col-6">
                                  <button
                                    className="btn btn-light w-100"
                                    onClick={() => {
                                      setFilterClients([]);
                                      setFilterProducts([]);
                                      setFilterStatuses([]);
                                      setSortOption("recently_added");
                                      setStatusFilter("all");
                                      setFilterOwners([]);
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button className="btn btn-primary w-100">
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                          <div className="view-icons">
                            <Link to="#" className="active">
                              <i className="ti ti-list-tree" />
                            </Link>
                            <Link to={route.InvoiceGrid}>
                              <i className="ti ti-grid-dots" />
                            </Link>
                          </div>
                        </div>
                      </div>

                     <div className="active-filters d-flex flex-wrap gap-2 mb-3">
                    {filterClients.length > 0 && (
                      <div
                        className="alert alert-primary py-2 mb-2"
                        role="alert"
                      >
                        Showing invoices with clients:{" "}
                        <strong>{filterClients.join(", ")}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setFilterClients([])}
                        ></i>
                      </div>
                    )}
                    {filterStatuses.length > 0 && (
                      <div
                        className="alert alert-primary py-2 mb-2"
                        role="alert"
                      >
                        Showing invoices with statuses:{" "}
                        <strong>{filterStatuses.join(", ")}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setFilterStatuses([])}
                        ></i>
                      </div>
                    )}
                    {filterProducts.length > 0 && (
                      <div
                        className="alert alert-primary py-2 mb-2"
                        role="alert"
                      >
                        Showing invoices with products:{" "}
                        <strong>{filterProducts.join(", ")}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setFilterProducts([])}
                        ></i>
                      </div>
                    )}
                    {filterOwners.length > 0 && (
                      <div
                        className="alert alert-primary py-2 mb-2"
                        role="alert"
                      >
                        Showing invoices with owners:{" "}
                        <strong>{filterOwners.join(", ")}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setFilterOwners([])}
                        ></i>
                      </div>
                    )}
                    {dateRange &&
  (normalizeDate(dateRange.start) !== normalizeDate(initialSettings.startDate) ||
    normalizeDate(dateRange.end) !== normalizeDate(initialSettings.endDate)) && (
    <span className="alert alert-success py-2 mb-2">
      <i className="ti ti-calendar-event" />

      {dateRange.start.toLocaleDateString("en-GB")} –{" "}
      {dateRange.end.toLocaleDateString("en-GB")}

      <i
        className="ti ti-x fs-12 cursor-pointer"
        onClick={() =>
          setDateRange({
            start: initialSettings.startDate,
            end: initialSettings.endDate,
          })
        }
      />
    </span>
  )}

                    {sortOption !== "recently_added" && (
                      <div
                        className="alert alert-primary py-2 mb-2"
                        role="alert"
                      >
                        Showing invoices sorted by:{" "}
                        <strong>{sortOption.replace(/_/g, " ")}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setSortOption("recently_added")}
                        ></i>
                      </div>
                    )}
                    {statusFilter !== "all" && (
                      <div className="alert alert-primary py-2 mb-2">
                        Showing invoices with status:{" "}
                        <strong>{statusFilter}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setStatusFilter("all")}
                        ></i>
                      </div>
                    )}
                    {searchText.length > 0 && (
                      <div className="alert alert-primary py-2 mb-2">
                        Showing invoices matching: <strong>{searchText}</strong>
                        <i
                          className="ti ti-x fs-12 cursor-pointer ms-2"
                          onClick={() => setSearchText("")}
                        ></i>
                      </div>
                    )}
                  </div>
                    </>

                    <div className="table-responsive custom-table">
                      <Table
                       dataSource={validInvoices}
                        columns={columns}
                        rowKey="invoice_proposal_id"
                        loading={loading}
                        className="custom-table"
                      emptyText="No Invoice found"
                      emptyIcon="ti ti-file-off"
                      enableRowSelection={true}
                        rowSelection={{
    type: "checkbox",
    selectedRowKeys: selectedInvoices,
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedInvoices(selectedRowKeys as string[]);
    },
  }}
                        pagination={{
                          current: currentPage,
                          pageSize: pageSize,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50"],
                          onChange: (page: number, size: number) => {
                            setCurrentPage(page);
                            setPageSize(size);
                          },
                        }}
                         recordLabel="Invoices"
                      draggable={true} // <-- ENABLE
                      enableColumnDrag={true}
                      onRowOrderChange={handleRowOrderChange}
                      onColumnOrderChange={(newCols: any[]) => {
                        const newKeys = newCols
                          .filter((c) => !c.fixed) // Only non-sticky columns
                          .map((c) => c.key ?? c.dataIndex);
                        setColumnKeys(newKeys);
                        // Don't auto-save, let user decide on navigation/refresh
                        // localStorage.setItem(
                        //   "invoicesColumnKeys",
                        //   JSON.stringify(newKeys)
                        // );
                      }} 
                        scroll={{ x: "max-content" }}
                        components={{
                          
                        }}
                      />
                    </div>

                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_add"
          ref={offcanvasRef}
          style={{ minWidth: "1024px" }}
        >
          <div className="offcanvas-header border-bottom">
            <h4>Add New Invoice</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={refresh}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <h6 className="mt-3 mb-3 border-bottom pb-1">
                <i className="ti ti-file-invoice me-2 text-primary" />
                Invoice Overview
              </h6>

              <div className="row">
                <div className="mb-3">
                  <label className="col-form-label">
                    Select Deal (Company)
                  </label>
                  <Select
                    options={[...deals].reverse().map((deal) => ({
                      value: deal.deal_id,
                      label: `${deal.contact.company_name} (${deal.contact.contact_person_name})`,
                    }))}
                    onChange={handleDealChange}
                    value={
                      selectedDeal
                        ? {
                            value: selectedDeal.deal_id,
                            label: `${selectedDeal.contact.company_name} (${selectedDeal.contact.contact_person_name})`,
                          }
                        : null
                    }
                    placeholder="Choose a Deal"
                  />
                </div>
                {selectedDeal && (
                  <>
                    <div className="col-md-6 mb-3">
                      <label className="col-form-label">Company Mail</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedDeal.contact.company_mail}
                        disabled
                        placeholder="Company email"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="col-form-label">Branch City</label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          selectedDeal.contact.branch?.[0]?.branch_city ?? "N/A"
                        }
                        disabled
                        placeholder="Branch city"
                      />
                    </div>
                  </>
                )}
              </div>
              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-calendar me-2 text-primary" />
                Dates & Status
              </h6>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="col-form-label">Invoice Date</label>
                  <DatePicker
                    className="form-control"
                    selected={invoiceDate}
                    onChange={setInvoiceDate}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select invoice date"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="col-form-label">Validation Date</label>
                  <DatePicker
                    className="form-control"
                    selected={validationDate}
                    onChange={setValidationDate}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select validation date"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="col-form-label">Status</label>
                  <Select
                    options={[
                      { value: "paid", label: "Paid" },
                      { value: "notpaid", label: "Not Paid" },
                    ]}
                    value={{
                      value: status,
                      label: status === "paid" ? "Paid" : "Not Paid",
                    }}
                    onChange={(opt) => setStatus(opt?.value ?? "notpaid")}
                    placeholder="Select status"
                  />
                </div>
              </div>
              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-report-analytics me-2 text-primary" />
                Product & Invoice Summary
              </h6>
              <div className="table-responsive mb-4">
                <table className="table table-view">
                  <thead>
                    <tr>
                      <th>Item (Product)</th>
                      <th>No.of Logins</th>
                      <th>Rate per Login</th>
                      <th>Discount (%)</th>
                      <th>CGST (%)</th>
                      <th>SGST (%)</th>
                      <th>IGST (%)</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={index}>
                        <td>
                          {row.product_name} ({row.product_price})
                        </td>
                        <td>{row.no_logins}</td>
                        <td>{Number(row.rate_per_login ?? 0).toFixed(2)}</td>
                        <td>{(row.proposal_discount ?? 0).toFixed(2)}%</td>
                        <td>{(row.cgst_percentage ?? 0).toFixed(2)}%</td>
                        <td>{(row.sgst_percentage ?? 0).toFixed(2)}%</td>
                        <td>{(row.igst_percentage ?? 0).toFixed(2)}%</td>
                        <td>{Number(row.amount ?? 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="subtotal-div mb-3">
                <ul className="mb-3">
                  <li>
                    <h5>Subtotal</h5>
                    <h6>{(subtotal ?? 0).toFixed(2)}</h6>
                  </li>
                  <li>
                    <h5>Discount</h5>
                    <h6>{(discount ?? 0).toFixed(2)}</h6>
                  </li>
                  <li>
                    <h5>CGST</h5>
                    <h6>{(cgst ?? 0).toFixed(2)}</h6>
                  </li>
                  <li>
                    <h5>SGST</h5>
                    <h6>{(sgst ?? 0).toFixed(2)}</h6>
                  </li>
                  <li>
                    <h5>IGST</h5>
                    <h6>{(igst ?? 0).toFixed(2)}</h6>
                  </li>
                  <li>
                    <h5>Total</h5>
                    <h6>{(total ?? 0).toFixed(2)}</h6>
                  </li>
                </ul>
              </div>
              {/* <div className="col-md-12 mb-3">
                  <label className="col-form-label">Notes</label>
                  <textarea
                    className="form-control"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    rows={4}
                    placeholder="Enter invoice notes"
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="col-form-label">Terms & Conditions</label>
                  <textarea
                    className="form-control"
                    value={terms}
                    onChange={(e) => setTerms(e.target.value)}
                    rows={4}
                    placeholder="Enter terms & conditions"
                  />
                </div> */}

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                  onClick={refresh}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Create Invoice
                </button>
              </div>
            </form>
          </div>
        </div>

        <div ref={invoiceRef}>
          <div className="modal fade" id="view_invoice" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-body p-5 a4-sheet">
                  {loading && <p>Loading Invoice...</p>}
                  {!loading && selectedInvoice && (
                    <>
                      <div className="row mb-4 header-section align-items-center">
                        <div className="col-md-6 d-flex flex-column justify-content-center">
                          <div className="mb-3">
                            <img
                              src="assets/img/favicon.png"
                              alt="logo"
                              crossOrigin="anonymous"
                              className="img-fluid"
                              style={{ width: "50%", height: "75%" }}
                            />
                          </div>
                          <div>
                            <h3 className="fw-bold mb-1">
                              EROYAL TECH SYSTEMS PRIVATE LIMITED
                            </h3>
                            <p className="mb-1 small">
                              No.8,(Old No.19), Second Floor,Second Cross Street
                            </p>
                            <p className="mb-1 small">
                              Kalaimgal Nagar,Ekkatuthangal, Chennai -600032
                            </p>
                            <span>
                              <p className="mb-1 small">
                                {selectedInvoice?.deal.contact.users?.name ||
                                  "Selva"}
                              </p>
                              <p className="mb-1 small">
                                {selectedInvoice?.deal.contact.users
                                  ?.phone_no || "8056069701"}
                              </p>
                            </span>
                            <p className="mb-1 small">
                              e-Mail ID:{" "}
                              {selectedInvoice?.deal?.contact.users?.email ||
                                "selva@royaltechsystems.co.in"}
                            </p>
                            <p className="mb-1 small">
                              Website: royaltechsystems.co.in
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-6 text-end"
                          style={{ marginTop: "110px" }}
                        >
                          <div className="quote-box">
                            <h2 className="fw-bold mb-2">INVOICE</h2>
                            <div className="quote-details text-start">
                              <div className="d-flex justify-content-between mb-1 align-items-center">
                                <span className="fw-medium">
                                  DATE{" "}
                                  <i
                                    className="ti ti-info-circle"
                                    data-bs-toggle="tooltip"
                                    title="The date the invoice was issued"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                  ></i>
                                </span>
                                <span>
                                  {new Date(
                                    selectedInvoice?.invoice_date ?? ""
                                  ).toLocaleDateString("en-GB")}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mb-1 align-items-center">
                                <span className="fw-medium">
                                  DUE DATE{" "}
                                  <i
                                    className="ti ti-info-circle"
                                    data-bs-toggle="tooltip"
                                    title="The date the invoice is due"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                  ></i>
                                </span>
                                <span>
                                  {new Date(
                                    selectedInvoice?.validation_date ?? ""
                                  ).toLocaleDateString("en-GB")}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-medium">
                                  INVOICE NO{" "}
                                  <i
                                    className="ti ti-info-circle"
                                    data-bs-toggle="tooltip"
                                    title="Unique invoice reference number"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                  ></i>
                                </span>
                                <span>
                                  {selectedInvoice?.invoice_proposal_id ??
                                    "N/A"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="bill-to-header">BILL TO</div>
                        <div className="bill-to-content">
                          <div className="row">
                            <div className="col-md-6">
                              <p className="mb-1">
                                <strong>Company Name:</strong>{" "}
                                {selectedInvoice?.deal?.contact?.company_name ??
                                  "N/A"}
                              </p>
                              <p className="mb-1">
                                <strong>Contact Person Name:</strong>{" "}
                                {selectedInvoice?.deal?.contact
                                  ?.contact_person_name ?? "N/A"}
                              </p>
                              <p className="mb-1">
                                <strong>E-Mail ID:</strong>{" "}
                                {selectedInvoice?.deal?.contact?.company_mail ??
                                  "N/A"}
                              </p>
                            </div>
                            <div className="col-md-6">
                              {selectedInvoice?.deal?.contact?.branch?.[0]
                                ?.branch_address && (
                                <p className="mb-1">
                                  <strong>Location:</strong>{" "}
                                  {
                                    selectedInvoice.deal.contact.branch[0]
                                      .branch_address
                                  }
                                </p>
                              )}
                              {selectedInvoice?.deal?.contact?.branch?.[0]
                                ?.branch_city && (
                                <p className="mb-1">
                                  <strong>City:</strong>{" "}
                                  {
                                    selectedInvoice.deal.contact.branch[0]
                                      .branch_city
                                  }
                                </p>
                              )}
                              {selectedInvoice?.deal?.contact?.branch?.[0]
                                ?.branch_state && (
                                <p className="mb-1">
                                  <strong>State:</strong>{" "}
                                  {
                                    selectedInvoice.deal.contact.branch[0]
                                      .branch_state
                                  }
                                </p>
                              )}
                              {selectedInvoice?.deal?.contact?.branch?.[0]
                                ?.branch_zipcode && (
                                <p className="mb-1">
                                  <strong>Zipcode:</strong>{" "}
                                  {
                                    selectedInvoice.deal.contact.branch[0]
                                      .branch_zipcode
                                  }
                                </p>
                              )}
                              {selectedInvoice?.deal?.contact?.branch?.[0]
                                ?.branch_country && (
                                <p className="mb-1">
                                  <strong>Country:</strong>{" "}
                                  {
                                    selectedInvoice.deal.contact.branch[0]
                                      .branch_country
                                  }
                                </p>
                              )}
                              {selectedInvoice?.deal?.contact?.branch?.[0]
                                ?.gst_number && (
                                <p className="mb-1">
                                  <strong>GST No:</strong>{" "}
                                  {
                                    selectedInvoice.deal.contact.branch[0]
                                      .gst_number
                                  }
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <table className="table table-bordered mb-4">
                        <thead>
                          <tr>
                            <th>DESCRIPTION</th>
                            <th className="text-end">NO OF LOGINS</th>
                            <th className="text-end">RATE</th>
                            <th className="text-end">AMOUNT</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <strong>
                                {selectedInvoice?.deal?.product?.product_name ??
                                  "N/A"}
                              </strong>
                              <br />
                              <small>
                                Total No{" "}
                                {selectedInvoice?.invoice_no_logins ?? "N/A"}{" "}
                                Logins
                              </small>
                            </td>
                            <td className="text-end">
                              {selectedInvoice?.invoice_no_logins ?? "N/A"}
                            </td>
                            <td className="text-end">
                              {formatNumber(
                                selectedInvoice?.invoice_rate_per_login ?? 0,
                                selectedInvoice?.deal?.currency ?? "USD"
                              )}
                            </td>
                            <td className="text-end">
                              {formatNumber(
                                selectedInvoice?.subtotalamount ?? 0,
                                selectedInvoice?.deal?.currency ?? "USD"
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3} className="text-end fw-bold">
                              {typeof selectedInvoice?.discount === "number" &&
                                selectedInvoice.discount > 0 && (
                                  <>
                                    Discount
                                    <br />
                                  </>
                                )}
                              {typeof selectedInvoice?.cgst === "number" &&
                                selectedInvoice.cgst > 0 && (
                                  <>
                                    CGST {selectedInvoice.cgst_percentage ?? 0}%
                                    <br />
                                  </>
                                )}
                              {typeof selectedInvoice?.sgst === "number" &&
                                selectedInvoice.sgst > 0 && (
                                  <>
                                    SGST {selectedInvoice.sgst_percentage ?? 0}%
                                    <br />
                                  </>
                                )}
                              {typeof selectedInvoice?.igst === "number" &&
                                selectedInvoice.igst > 0 && (
                                  <>
                                    IGST {selectedInvoice.igst_percentage ?? 0}%
                                    <br />
                                  </>
                                )}
                              Total Amount
                            </td>
                            <td className="text-end">
                              {typeof selectedInvoice?.discount === "number" &&
                                selectedInvoice.discount > 0 && (
                                  <>
                                    {formatNumber(
                                      selectedInvoice.discount ?? 0,
                                      selectedInvoice?.deal?.currency ?? "USD"
                                    )}
                                    <br />
                                  </>
                                )}
                              {typeof selectedInvoice?.cgst === "number" &&
                                selectedInvoice.cgst > 0 && (
                                  <>
                                    {formatNumber(
                                      selectedInvoice.cgst ?? 0,
                                      selectedInvoice?.deal?.currency ?? "USD"
                                    )}
                                    <br />
                                  </>
                                )}
                              {typeof selectedInvoice?.sgst === "number" &&
                                selectedInvoice.sgst > 0 && (
                                  <>
                                    {formatNumber(
                                      selectedInvoice.sgst ?? 0,
                                      selectedInvoice?.deal?.currency ?? "USD"
                                    )}
                                    <br />
                                  </>
                                )}
                              {typeof selectedInvoice?.igst === "number" &&
                                selectedInvoice.igst > 0 && (
                                  <>
                                    {formatNumber(
                                      selectedInvoice.igst ?? 0,
                                      selectedInvoice?.deal?.currency ?? "USD"
                                    )}
                                    <br />
                                  </>
                                )}
                              <strong>
                                {formatNumber(
                                  selectedInvoice?.invoice_total_amount ?? 0,
                                  selectedInvoice?.deal?.currency ?? "USD"
                                )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div className="mb-4">
                        <div className="terms-header">Terms & Conditions:</div>
                        <div className="terms-content">
                          <div className="row">
                            <div className="col-md-6">
                              <p className="mb-2">
                                <strong>1.</strong> Payment Terms: Payment at
                                the time of order.
                              </p>
                              <p className="mb-2">
                                <strong>2.</strong> Cheque should be drawn in
                                favor of
                                <strong className="company-name ms-1">
                                  EROYAL TECH SYSTEMS PRIVATE LIMITED
                                </strong>
                              </p>
                              <p className="mb-2">
                                <strong>3.</strong> Taxes : All the tax are
                                applicable as per Government rule.
                              </p>
                              <p className="mb-2">
                                <strong>4.</strong> AMC, Per Login Rs. 8000/- +
                                Gst. Second Year Onwards.
                              </p>
                              <p className="mb-0">
                                <strong>5.</strong> If Required Tally
                                Integration for Accounts Charges Rs.10000/- +
                                Gst.
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p className="mb-2">
                                <strong>For Online Payment :</strong>
                              </p>
                              <p className="mb-1">
                                <strong>A/c Name :</strong> EROYAL TECH SYSTEMS
                                PRIVATE LIMITED
                              </p>
                              <p className="mb-1">
                                <strong>Bank Name :</strong> Axis Bank
                              </p>
                              <p className="mb-1">
                                <strong>A/c No :</strong> 921020017148861
                              </p>
                              <p className="mb-1">
                                <strong>Branch :</strong> Kattupakkam, Chennai
                              </p>
                              <p className="mb-1">
                                <strong>IFSC Code :</strong> UTIB0002958
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="text-center mb-3 footer-contact">
                        <p className="mb-2">
                          If you have any questions about this invoice, please
                          contact
                        </p>
                        <p className="mb-3">
                          <strong>
                            [Name:{" "}
                            {selectedInvoice?.deal.contact.users?.name ||
                              "Selva"}
                            , Mobile:{" "}
                            {selectedInvoice?.deal.contact.users?.phone_no ||
                              "8056069701"}
                            , E-mail:{" "}
                            {selectedInvoice?.deal?.contact.users?.email ||
                              "selva@royaltechsystems.co.in"}
                            ]
                          </strong>
                        </p>
                        <p className="fw-bold thank-you">
                          Thank You For Your Business!
                        </p>
                      </div>
                    </>
                  )}
                  {!loading && !selectedInvoice && <p>No Invoice selected.</p>}
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary no-print"
                      onClick={handleDownloadPDF}
                    >
                      <i className="ti ti-download me-1"></i> Download Invoice
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
        show={showBulkDeleteModal}
        onHide={() => {
          if (!isDeleting) setShowBulkDeleteModal(false);
        }}
        centered
        backdrop="static"
        className="effect-modal-show"
      >
        <div className="modal-header">
          <h5 className="modal-title text-danger fw-bold" id="bulkDeleteInvoicesLabel">
            <i className="ti ti-alert-triangle me-2" />
            Confirm Bulk Deletion
          </h5>
          <button
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            aria-label="Close"
            onClick={() => {
              if (!isDeleting) setShowBulkDeleteModal(false);
            }}
            disabled={isDeleting}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body text-center">
          <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
            <i className="ti ti-trash fs-40 text-danger" />
          </div>
          <h4 className="fw-bold text-dark mb-3">
            Delete {selectedInvoices.length} Invoice{selectedInvoices.length > 1 ? "s" : ""}?
          </h4>
          <p className="text-muted fs-15 mb-4 px-4">
            This action <strong>cannot be undone</strong>.
            The selected invoices will be
            <strong> permanently removed</strong> from
            your system.
          </p>
          <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
            <i className="ti ti-info-circle me-2" />
            <strong>Warning:</strong> This may affect
            related records, payments, and financial data.
          </div>
          <div className="d-flex gap-3 justify-content-center mt-4">
            <button
              type="button"
              className="btn btn-light px-5 py-2 fw-medium"
              onClick={() => setShowBulkDeleteModal(false)}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger px-5 py-2 fw-medium"
              onClick={async () => {
                await handleBulkDelete();
                setShowBulkDeleteModal(false);
              }}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Deleting...
                </>
              ) : (
                <>
                  <i className="ti ti-trash me-2" />
                  Yes, Delete Permanently
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
      <ModalDeleteEffect />

        <div className="modal fade effect-modal-show" id="delete_invoice" tabIndex={-1} role="dialog" aria-labelledby="deleteInvoiceLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-danger fw-bold" id="deleteInvoiceLabel">
                <i className="ti ti-alert-triangle me-2" />
                Confirm Deletion
              </h5>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={isDeleting}
                onClick={() => {
                  if (!isDeleting) {/* optional: close logic if needed */ }
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body text-center">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                <i className="ti ti-trash fs-40 text-danger" />
              </div>

              {/* Dynamic invoice name display */}
              {deleteInvoiceId &&
                invoices.find((i) => i.invoice_proposal_id === deleteInvoiceId) && (
                  <h4 className="fw-bold text-dark mb-3">
                    Delete "
                    {invoices.find((i) => i.invoice_proposal_id === deleteInvoiceId)?.deal?.leads?.contact?.contact_name ||
                      invoices.find((i) => i.invoice_proposal_id === deleteInvoiceId)?.deal?.leads?.contact?.contact_persona_name ||
                      "this invoice"}
                    "?
                  </h4>
                )}

              {!deleteInvoiceId && (
                <h4 className="fw-bold text-dark mb-3">Delete This Invoice?</h4>
              )}

              <p className="text-muted fs-15 mb-4 px-4">
                This action <strong>cannot be undone</strong>. The invoice will be
                <strong> permanently removed</strong> from your system.
              </p>

              <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                <i className="ti ti-info-circle me-2" />
                <strong>Warning:</strong> All associated data (installments, payments, notes) will also be deleted.
              </div>

              <div className="d-flex gap-3 justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-light px-5 py-2 fw-medium"
                  data-bs-dismiss="modal"
                  disabled={isDeleting}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger px-5 py-2 fw-medium"
                  onClick={handleConfirmDelete}
                  data-bs-dismiss="modal"
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-trash me-2" />
                      Yes, Delete It
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
        {/* Invoice Details Modal */}
      <InvoiceDetailsModal
        invoice={selectedInvoiceForView}
        isOpen={showViewInvoiceModal}
        onClose={() => {
          setShowViewInvoiceModal(false);
          setSelectedInvoiceForView(null);
        }}
      />

      {/* Save Column Order Modal */}
      <SaveModal />
      <ScrollToTop />
      </>
    </div>
  );
};

export default InvoiceList;
